import React from "react";
import clsx from "clsx";
import * as styles from "./component.module.scss";

const ButtonBluer = ({
  linkTo,
  variant,
  children,
}: {
  children?: React.ReactNode;
  variant?: "slim";
  linkTo?: string;
}) => {
  const BaseElement = linkTo ? "a" : "button";

  return (
    <BaseElement
      className={clsx(styles.main, variant === "slim" && styles.slim)}
      href={linkTo}
      target={linkTo?.includes("://") ? "_blank" : undefined}
    >
      {children}
    </BaseElement>
  );
};

export default ButtonBluer;
